// @ts-ignore

import Vehicle from '@/models/Vehicle'
import {
	cloneDeep as _cloneDeep,
	find as _find,
	has as _has,
	isEmpty as _isEmpty,
	startCase as _startCase,
	toLower as _toLower,
	upperFirst as _upperFirst,
} from 'lodash-es'
import { acceptHMRUpdate, defineStore } from 'pinia'
import qs from 'qs'

const defaultSortBy = computed(() => 'recentlyadded')

// Car Subscription Prices
const priceOptions = [
	{
		label: 'Any',
		value: 'all',
	},
	{
		label: '$100/per week',
		value: '100',
	},
	{
		label: '$150/per week',
		value: '150',
	},
	{
		label: '$200/per week',
		value: '200',
	},
	{
		label: '$250/per week',
		value: '250',
	},
	{
		label: '$300/per week',
		value: '300',
	},
	{
		label: '$350/per week',
		value: '350',
	},
	{
		label: '$400/per week',
		value: '400',
	},
]

// Buy Used Car Prices
const priceUsedStart = 10000
const priceUsedIncrement = 10000
const priceUsedOptions = [
	{
		label: 'Any',
		value: 'all',
	},
	...new Array(15).fill(undefined).map((item, index) => ({
		label: `$${(
			priceUsedStart +
			index * priceUsedIncrement
		).toLocaleString()}`,
		value: priceUsedStart + index * priceUsedIncrement,
		count: null,
	})),
]

// Odometer
const odometerStart = 10000
const odometerIncrement = 10000
const odometerOptionsFrom = [
	{
		label: 'Min',
		value: 'all',
	},
	...new Array(15).fill(undefined).map((item, index) => ({
		label: `${(
			odometerStart +
			index * odometerIncrement
		).toLocaleString()} km`,
		value: odometerStart + index * odometerIncrement,
		count: null,
	})),
]
const odometerOptionsTo = [
	{
		label: 'Max',
		value: 'all',
	},
	...new Array(15).fill(undefined).map((item, index) => ({
		label: `${(
			odometerStart +
			index * odometerIncrement
		).toLocaleString()} km`,
		value: odometerStart + index * odometerIncrement,
		count: null,
	})),
]

// // Year
const currentYear = new Date().getFullYear()
const yearOptions = [
	{
		label: 'Any',
		value: 'all',
	},
	...new Array(6).fill(undefined).map((item, index) => ({
		label: currentYear - index,
		value: currentYear - index,
		count: null,
	})),
]

const conditionOptions = [
	{
		label: 'New',
		value: 'new',
		count: null,
	},
	{
		label: 'Used',
		value: 'used',
		count: null,
	},
]

const bodyTypeOptions = [
	{ label: 'SUV', value: 'suv', count: null },
	{ label: 'Coupe', value: 'coupe', count: null },
	{ label: 'Wagon', value: 'wagon', count: null },
	{ label: 'Liftback', value: 'liftback', count: null },
	{ label: 'Softtop', value: 'softtop', count: null },
	{ label: 'Utility Vehicle', value: 'utility vehicle', count: null },
	{ label: 'Commercial Vehicle', value: 'commercial vehicle', count: null },
	{ label: 'Utility', value: 'utility', count: null },
	{ label: 'Cabriolet', value: 'cabriolet', count: null },
	{ label: 'People Mover', value: 'people mover', count: null },
	{ label: 'Bus', value: 'bus', count: null },
	{ label: 'Cab Chassis', value: 'cab chassis', count: null },
	{ label: 'Light Truck', value: 'light truck', count: null },
	{ label: 'Van', value: 'van', count: null },
	{ label: 'Hardtop', value: 'hardtop', count: null },
	{ label: 'Roadster', value: 'roadster', count: null },
	{ label: 'Sportswagon', value: 'sportswagon', count: null },
	{ label: 'Fastback', value: 'fastback', count: null },
	{ label: 'Dual Cab', value: 'dual cab', count: null },
	{ label: 'Fastbook', value: 'Fastbook', count: null },
	{ label: 'WAG', value: 'wag', count: null },
	{ label: 'RDSTR', value: 'rdstr', count: null },
	{ label: 'HATCH', value: 'hatch', count: null },
	{ label: 'UTIL', value: 'util', count: null },
	{ label: 'TOURER', value: 'tourer', count: null },
	{ label: 'UTE', value: 'ute', count: null },
	{ label: 'Hatchback', value: 'hatchback', count: null },
	{ label: 'Sedan', value: 'sedan', count: null },
	{ label: 'Convertible', value: 'convertible', count: null },
	{ label: 'Crew Cab Utility', value: 'crew cab utility', count: null },
	{ label: 'Crew Cab Pickup', value: 'crew cab pickup', count: null },
	{ label: 'Crew Cab Chassis', value: 'crew cab chassis', count: null },
	{ label: 'Dual Cab Utility', value: 'dual cab utility', count: null },
	{ label: 'Dual Cab Pick-up', value: 'dual cab pick-up', count: null },
	{
		label: 'CAB CHASSIS SINGLE CAB',
		value: 'cab chassis single cab',
		count: null,
	},
	{ label: 'Super Cab Utility', value: 'super cab utility', count: null },
	{ label: 'X Cab Pickup', value: 'x cab pickup', count: null },
	{ label: 'Leaf Cab Chassis', value: 'leaf cab chassis', count: null },
	{ label: 'Double Cab Utility', value: 'double cab utility', count: null },
	{ label: 'Dual Cab Chassis', value: 'dual cab chassis', count: null },
	{ label: 'Club Cab Chassis', value: 'club cab chassis', count: null },
	{ label: 'Super Cab Chassis', value: 'super cab chassis', count: null },
	{
		label: 'CAB CHASSIS EXTENDED CAB',
		value: 'cab chassis extended cab',
		count: null,
	},
	{ label: 'Van Wagon', value: 'van wagon', count: null },
	{ label: 'Double Cab Pick Up', value: 'double cab pick up', count: null },
	{ label: 'Refrigerated Van', value: 'refrigerated van', count: null },
	{
		label: 'Freestyle Cab Chassis',
		value: 'freestyle cab chassis',
		count: null,
	},
	{ label: 'Targa', value: 'targa', count: null },
]

const transmissionOptions = [
	{
		label: 'Automatic',
		value: 'automatic',
		count: null,
	},
	{
		label: 'Manual',
		value: 'manual',
		count: null,
	},
]

const driveTypeOptions = [
	{
		label: 'Four wheel drive',
		value: 'four',
		count: null,
	},
	{
		label: 'Front wheel drive',
		value: 'front',
		count: null,
	},
	{
		label: 'Rear wheel drive',
		value: 'rear',
		count: null,
	},
]

const seatOptions = [1, 2, 3, 4, 5, 6, '7plus'].map((item) => ({
	label: item === '7plus' ? '7+' : item,
	value: item,
	count: null,
}))

const fuelTypeOptions = [
	'Petrol or LPG (Dual)',
	'Petrol or CNG (Dual)',
	'Petrol - Unleaded ULP',
	'Petrol - Premium ULP',
	'Petrol',
	'LPG only',
	'Hydrogen',
	'Electric',
	'Diesel',
].map((item) => ({
	label: item,
	value: item.toLowerCase(),
	count: null,
}))

const sortByOptions = [
	{
		label: 'Lowest price',
		slug: 'price',
	},
	{
		label: 'Highest price',
		slug: '-price',
	},
	{
		label: 'Newest age',
		slug: '-year',
	},
	{
		label: 'Oldest age',
		slug: 'year',
	},
	// {
	// 	label: 'Featured',
	// 	slug: 'featured',
	// },
	{
		label: 'Recently added',
		slug: 'recentlyadded',
	},
	{
		label: 'Available now',
		slug: 'availablenow',
	},
]

const stateOptions = [
	{
		label: 'All',
		value: 'all',
	},
	{
		label: 'Queensland (QLD)',
		value: 'qld',
		count: null,
		hidden: true,
	},
	{
		label: 'Brisbane',
		value: 'brisbane',
		count: null,
		countValue: 'qld',
	},
	{
		label: 'Australia Capital Territory (ACT)',
		value: 'act',
		count: null,
		hidden: true,
	},
	{
		label: 'Canberra',
		value: 'canberra',
		count: null,
		countValue: 'act',
	},
	{
		label: 'Victoria (VIC)',
		value: 'vic',
		count: null,
		hidden: true,
	},
	{
		label: 'Melbourne',
		value: 'melbourne',
		count: null,
		countValue: 'vic',
	},
	{
		label: 'New South Wales (NSW)',
		value: 'nsw',
		count: null,
		hidden: true,
	},
	{
		label: 'Sydney',
		value: 'sydney',
		count: null,
		countValue: 'nsw',
	},
	// {
	// 	label: 'Tasmania (TAS)',
	// 	value: 'tas',
	// 	count: null,
	// },
	// {
	// 	label: 'Hobart',
	// 	value: 'hobart',
	// 	class: 'ml-6',
	// 	hidden: true,
	// },
]

const subscriptionPageTitles = {
	default: {
		title: 'View Our Range of Subscription Cars Available {{ page }}| carbar Australia',
		description:
			'Car subscription is the new way to own a car without the commitment. View our range of available cars & subscribe now.',
	},
	state: {
		title: 'View Our Range of Subscriptions Cars Available in {{ slug }} {{ page }}| carbar Australia',
		description:
			'Car subscription is the new way to own a car without the commitment. View our range of available cars & subscribe now.',
	},
	make: {
		title: 'Subscribe to a {{ slug }} Online Today {{ page }}| carbar Australia',
		description:
			'Rather than buying, you can subscribe to a {{ slug }} online with carbar. Enjoy all the perks of traditional car ownership without the commitments. Subscribe Now.',
	},
	model: {
		title: 'Subscribe to a {{ slug }} Online {{ page }}| carbar Australia',
		description:
			'With a {{ slug }} subscription, you can enjoy the benefits of car ownership without the bills. The best part is, you can stop or swap with just 2 weeks notice.',
	},
	makebodytype: {
		title: 'Subscribe to Your Favourite {{ slug }} {{ page }}| carbar Australia',
		description:
			'Subscribing to a {{ slug }} can give you all the new car feels without the financial stress. Simply subscribe online & pick-up your car from any of our offices in Brisbane, Melbourne or Sydney.',
	},
	bodytype: {
		title: 'Find the Perfect {{ slug }} Subscription Online {{ page }}| carbar Australia',
		description:
			"If you're looking for a {{ slug }}, carbar has the one for you. You can subscribe online & enjoy the flexibility of a car subscription.",
	},
	fueltype: {
		title: 'Subscribe to a {{ slug }} Vehicle Online {{ page }}| carbar Australia',
		description:
			'We all have a preference when it comes to our cars. If a vehicle that uses {{ slug }} is yours, then we have a range to suit you. Compare & subscribe online!',
	},
}

const makeOrList = (arr) => {
	if (arr.length === 0) {
		return ''
	}
	return arr.length > 1
		? `${arr.slice(0, -1).join(',')} or ${arr.slice(-1)}`
		: arr[0]
}

const getFilterUrlWithPageNumber = (state, pageNumber) => {
	const url = []

	const urlFilters = _cloneDeep(state.filters)

	if (urlFilters.states.length) {
		url.push(urlFilters.states.sort().join(','))
	}

	if (urlFilters.makes.length) {
		url.push(urlFilters.makes.sort().join(','))
	}

	if (urlFilters.makes.length && urlFilters.models.length) {
		url.push(urlFilters.models.sort().join(','))
	}

	if (urlFilters.bodyTypes.length) {
		url.push(`${urlFilters.bodyTypes.sort().join(',')}`)
	}

	if (urlFilters.fuelTypes.length) {
		url.push(`${urlFilters.fuelTypes.sort().join(',')}`)
	}

	delete urlFilters.states
	delete urlFilters.makes
	delete urlFilters.models
	delete urlFilters.bodyTypes
	delete urlFilters.fuelTypes

	if (urlFilters.sortBy === defaultSortBy) {
		delete urlFilters.sortBy
	}

	let page = 1
	if (pageNumber) {
		page = pageNumber
	} else if (state.productsPagination.filterNextPage) {
		page = state.productsPagination.filterNextPage
	} else {
		page = state.productsPagination.currentPage
	}

	if (page > 1) {
		urlFilters.page = page
	}

	let pagePath = ''
	const { pageType, partnerKey } = state

	if (pageType === 'used') {
		pagePath = '/cars/buy/used'
	} else if (pageType === 'subscribe') {
		pagePath = '/cars/subscribe'
	} else if (partnerKey) {
		pagePath = `/partners/${partnerKey}/browse`
	}

	const urlObject = {
		path: `${pagePath}/${url.join('/')}`,
		query: Object.fromEntries(
			Object.entries(urlFilters).filter(
				// eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
				([_, v]) =>
					v != null &&
					((Array.isArray(v) && v.length > 0) ||
						(typeof v === 'number' && v > 0) ||
						(typeof v === 'string' && v !== ''))
			)
		),
	}

	// remove trailing slash if present
	if (urlObject.path.slice(-1) === '/') {
		urlObject.path = urlObject.path.slice(0, urlObject.path.length - 1)
	}

	// we don't want to encode the URL as we're running comparisons against none encoded versions
	urlObject.querystring = Object.keys(urlObject.query).length
		? `?${qs.stringify(urlObject.query, { encode: false })}`
		: ''

	return urlObject
}

const isFiltersTheSame = (oldFilter, newFilter) => {
	const newFilterToCompare = Array.isArray(newFilter)
		? newFilter.sort().join('')
		: newFilter

	const rawOldFilter = toRaw(oldFilter)

	const oldFilterToCompare = Array.isArray(rawOldFilter)
		? rawOldFilter.sort().join('')
		: rawOldFilter

	return newFilterToCompare === oldFilterToCompare
}

export const getDefaultFiltersState = () => ({
	priceFrom: null,
	priceTo: null,
	priceUsedFrom: null,
	priceUsedTo: null,
	odometerFrom: null,
	odometerTo: null,
	makes: [],
	models: [],
	conditions: [],
	bodyTypes: [],
	features: [],
	yearFrom: null,
	yearTo: null,
	transmissions: [],
	fuelTypes: [],
	driveTypes: [],
	doors: [],
	seats: [],
	states: [],
	sortBy: defaultSortBy,
})

export const getDefaultFacetState = () => ({
	priceFrom: priceOptions,
	priceTo: priceOptions,
	priceUsedFrom: priceUsedOptions,
	priceUsedTo: priceUsedOptions,
	odometerFrom: odometerOptionsFrom,
	odometerTo: odometerOptionsTo,
	makes: [],
	models: [],
	conditions: conditionOptions,
	bodyTypes: bodyTypeOptions,
	features: [],
	yearFrom: yearOptions,
	yearTo: yearOptions,
	transmissions: transmissionOptions,
	fuelTypes: fuelTypeOptions,
	driveTypes: driveTypeOptions,
	doors: [],
	seats: seatOptions,
	states: stateOptions,
	sortBy: sortByOptions,
})

export const getSimilarVehicles = async (filters, limit) => {
	if (import.meta.prerender) {
		return []
	}

	let queryPath = 'v2/vehicles'

	const query = Vehicle.custom(queryPath).limit(limit)

	if (filters) {
		for (const [filterKey, filterValue] of Object.entries(filters)) {
			if (Array.isArray(filterValue)) {
				query.whereIn(filterKey, filterValue)
			} else {
				query.where(filterKey, filterValue)
			}
		}
	}
	query.cancelKey('similar-vehicles').params({ 'exclude-facets': true })

	const { items } = await query.get()
	return items || []
}

export const useProductCatalog = defineStore('productCatalog', {
	id: 'product-catalog',
	namespaced: true,
	state: () => ({
		pageType: '',
		partnerKey: '',
		products: [],
		productsPagination: {
			total: 0,
			currentPage: 1,
			lastPage: 1,
			perPage: 20,
			isLastPage: false,
			nextPage: null,
			prevPage: null,
			filterNextPage: null,
		},
		filters: getDefaultFiltersState(),
		facets: getDefaultFacetState(),
		sort: defaultSortBy,
		// list of facet options that are hardcoded and not relying on the API
		// so that we know not to overwrite the filtered facet options from the API
		// we only update the `count` from the API for each facet option
		predefinedFacets: [
			'conditions',
			'transmissions',
			'seats',
			'driveTypes',
			'states',
			'fuelTypes',
		],
		// to check if the facets/products mutated at least one time
		isFiltering: false,
		// to check if the initial page loaded
		isDirty: false,
		// to check whether to ignore any filter changes
		isSilentFilter: false,
		showMobileFilter: false,
		// check whether the URL is prefiltered
		// possible types are model, bodytype, make-bodytype, fueltype
		routeFilterType: null,
	}),
	getters: {
		getQueryPath() {
			let queryPath = 'v2/vehicles'
			return queryPath
		},
		getCurrentQuery() {
			const query = Vehicle.custom(this.getQueryPath)

			for (const [filterKey, filterValue] of Object.entries(
				this.activeFilters
			)) {
				if (filterKey === 'sortBy') {
					if (filterValue === defaultSortBy) {
						continue
					}
					query.orderBy(filterValue)

					continue
				}

				if (
					filterValue === 'all' ||
					(Array.isArray(filterValue) && filterValue.includes('all'))
				) {
					continue
				}

				if (Array.isArray(filterValue)) {
					query.whereIn(filterKey, filterValue)
				} else {
					query.where(filterKey, filterValue)
				}
			}

			const page = this.productsPagination.filterNextPage
				? parseInt(this.productsPagination.filterNextPage, 10)
				: parseInt(this.productsPagination.currentPage, 10)

			if (page > 1) {
				query.page(page)
			}

			// const { partnerName } = useGetPartnerName()

			// query.params({
			// 	'filter-facets': true,
			// 	partner: partnerName.value,
			// })

			return query
		},
		activeFilters() {
			const activeFilters = {}

			Object.entries(this.filters).forEach(([key, item]) => {
				if (item === null) {
					return
				}

				if (Array.isArray(item) && item.length === 0) {
					return
				}

				activeFilters[key] = item
			})

			return activeFilters
		},
		getFilterUrl(state) {
			return getFilterUrlWithPageNumber(state)
		},
		getPrevFilterUrl(state) {
			if (!state.productsPagination.prevPage) {
				return null
			}

			return getFilterUrlWithPageNumber(
				state,
				state.productsPagination.prevPage
			)
		},
		getNextFilterUrl(state) {
			if (!state.productsPagination.nextPage) {
				return null
			}

			return getFilterUrlWithPageNumber(
				state,
				state.productsPagination.nextPage
			)
		},
	},
	actions: {
		updateFacets(payload) {
			// ref - https://v3.vuejs.org/guide/change-detection.html#declaring-reactive-properties
			this.facets = { ...this.facets, ...payload }
		},
		getFilteredModels(makeNameToRemove, models) {
			// we're removing a make, therefore we need to remove any models associated with it
			let filterModels = []

			if (models && models.length) {
				// this solution isn't fast - it may be better to make product-catalog have an indexed object
				// for faster lookups
				filterModels = models.filter((modelItem) => {
					const facetItem = _find(
						this.facets.models,
						(innerFacetItem) => innerFacetItem.value === modelItem
					)
					return facetItem && facetItem.make !== makeNameToRemove
				})
			}

			return filterModels
		},
		async updateFilters(payload) {
			if (payload.overwrite) {
				this.filters = Object.assign(
					getDefaultFiltersState(),
					payload.filters
				)
			} else {
				this.filters = { ...this.filters, ...payload.filters }
			}

			// wait for the next tick - this resolves the bug wherein the removeFilterCloud is clicked, but
			// the URL/localStorage is lagging behind and thus the filter is never removed
			await nextTick()

			if (
				payload.doNotSetIsDirty === undefined ||
				!payload.doNotSetIsDirty
			) {
				this.setIsDirtyState(true)
			}
		},
		async updateFilter(payload) {
			// payload will be a filterKey and filterValue
			if (
				typeof payload.filterKey === 'undefined' ||
				typeof payload.filterValue === 'undefined'
			) {
				return
			}

			// copy the filters to avoid trigger any watchers - we're calling updateFilters at the end
			// clone the payload as it appears to be a reference to filters and we want to control
			//    when it is updated
			const filterCopy = _cloneDeep(this.filters)
			const payloadCopy = _cloneDeep(payload)

			// if the filters haven't changed, return immediately to avoid refiltering
			if (
				isFiltersTheSame(
					filterCopy[payloadCopy.filterKey],
					payloadCopy.filterValue
				)
			) {
				return
			}

			// setting the default mode to be 'overwrite' for both single and multiple value filters
			payloadCopy.overwrite =
				typeof payload.overwrite === 'undefined'
					? true
					: payload.overwrite

			const isFilterMultiple = Array.isArray(
				filterCopy[payloadCopy.filterKey]
			)
			const isFilterSingle = !isFilterMultiple
			const isOverwriting = payloadCopy.overwrite || isFilterSingle

			// if we're updating the makes filter, we need to remove any associated models
			if (payloadCopy.filterKey === 'makes') {
				// find which makes were removed
				const updatedMakes = toRaw(payloadCopy.filterValue)
				const makesRemoved = toRaw(filterCopy.makes).filter(
					(x) => !updatedMakes.includes(x)
				)

				makesRemoved.forEach((make) => {
					filterCopy.models = this.getFilteredModels(
						make,
						filterCopy.models
					)
				})
			}

			if (isOverwriting) {
				filterCopy[payloadCopy.filterKey] = payloadCopy.filterValue
			} else {
				// at this point, it is a multiple filter and merging an item //
				payloadCopy.filterValue = Array.isArray(payloadCopy.filterValue)
					? payloadCopy.filterValue
					: [payloadCopy.filterValue]

				// merge old & new values without any duplicates // ref - https://stackoverflow.com/a/48130841
				filterCopy[payloadCopy.filterKey] = [
					...new Set([
						...this.filters[payloadCopy.filterKey],
						...payloadCopy.filterValue,
					]),
				]
			}

			await this.updateFilters({ filters: filterCopy, overwrite: true })
		},
		removeFilter(payload) {
			// const that = this
			const filters = {}

			const payloadAsArray = Array.isArray(payload) ? payload : [payload]

			payloadAsArray.forEach((item) => {
				// normalizing multiple type of inputs
				// like ['bodyType'] OR [{filterKey: 'bodyType'}] OR [{filterKey: 'bodyType', filterValue: 99}]
				// absence of filterValue means it's a clear all

				item = item.filterKey ? item : { filterKey: item }

				filters[item.filterKey] = _has(filters, item.filterKey)
					? filters[item.filterKey]
					: this.filters[item.filterKey]
				const isFilterMultiple = Array.isArray(filters[item.filterKey])
				const isFilterSingle = !isFilterMultiple
				const clearAll = !item.filterValue

				if (item.filterKey === 'makes') {
					// we're removing a make, therefore we need to remove any models associated with it
					filters.models = this.getFilteredModels(
						item.filterValue,
						filters.models
					)
				}

				if (isFilterSingle) {
					filters[item.filterKey] = null
					return
				}

				if (isFilterMultiple && clearAll) {
					filters[item.filterKey] = []
					return
				}

				// at this point, it is a multiple filter and removing a specific item

				const filterValueIndex = filters[item.filterKey].indexOf(
					item.filterValue
				)

				filters[item.filterKey].splice(filterValueIndex, 1)
			})

			this.updateFilters({ filters })
		},
		clearFilter() {
			Object.assign(this.filters, getDefaultFiltersState())
		},

		filter() {
			this.setFilteringState(true)

			const { partnerName } = useGetPartnerName()
			const isPartner = !!partnerName.value

			// Base query instance
			const baseQuery = this.getCurrentQuery

			// Request 1: Facets
			if (!baseQuery.params['exclude-facets']) {
				const facetQuery = _cloneDeep(baseQuery)

				facetQuery
					.cancelKey(`facets`) // Set the key here
					.params({
						'facets-only': true,
						'filter-facets': true,
						...(isPartner && { _tenant: partnerName.value }),
					})
					.get()
					.then((data) => this.handleFacetsResponse(data))
					.catch((err) => err.name !== 'AbortError')
			}

			// Request 2: Results
			const resultsQuery = _cloneDeep(baseQuery)

			resultsQuery
				.cancelKey(`results`) // Set the key here
				.params({
					'exclude-facets': true,
					'page[size]': isPartner ? 20 : 19,
					...(isPartner && { _tenant: partnerName.value }),
				})
				.get()
				.then((data) => {
					this.handleFilterResponse(data)
					this.setFilteringState(false)
				})
				.catch((err) => {
					if (err.name === 'AbortError') return
				})
		},

		filterOnly(limit) {
			this.setFilteringState(true)

			const query = this.getCurrentQuery

			query.limit(limit)

			if (!query.params['exclude-facets']) {
				query.params({ 'exclude-facets': true })
			}

			query.get().then((data) => {
				this.setFilteringState(false)

				this.handleFilterResponse(data)
			})
		},

		async handleFilterResponse(payload) {
			if (_isEmpty(payload)) {
				return
			}

			const responseProducts = payload.items ? payload.items : []

			const responseMeta = payload.meta ? payload.meta : {}

			await this.setProducts(responseProducts)

			await this.updateProductsPagination({
				total: responseMeta.total
					? parseInt(responseMeta.total, 10)
					: 0,
				currentPage: responseMeta.current_page
					? parseInt(responseMeta.current_page, 10)
					: 1,
				lastPage: responseMeta.last_page
					? parseInt(responseMeta.last_page, 10)
					: 1,
				perPage: responseMeta.per_page
					? parseInt(responseMeta.per_page, 10)
					: 20,
			})
		},
		async handleFacetsResponse(payload) {
			// This function handles all facets and reassigns them with their respective options.
			const responseFacets = payload.facets ? payload.facets : {}
			const facets = {}

			for (const [responseFacetKey, responseFacetItem] of Object.entries(
				responseFacets
			)) {
				if (!this.facets[responseFacetKey]) {
					// we don't want to break when the API is returning a facet we don't know about

					continue
				}

				if (this.predefinedFacets.includes(responseFacetKey)) {
					this.facets[responseFacetKey].forEach(
						(facetItem, facetItemIndex) => {
							// handle both CSV and non-CSV based facet counts from the API response
							// for CSV based example, the sample API response facet options for states will be,
							// states.option[ {count: 81, value: "act,nsw"}, {count: 3, value: "act,qld,nsw,vic"}, {count: 72, value: "qld"} ]
							// so we are cross-matching the current store facet options VS response facet options
							// let's assume facetItem.value = 'nsw' and matchedOptions will be [ {count: 81, value: "act,nsw"}, {count: 3, value: "act,qld,nsw,vic"}]
							// force incoming item value to lowercase, in order to match with predefined facets' value which are lowercase.
							// some options (e.g. city-level states) carry a countValue
							// to borrow their parent's count from the API response.
							const matchValue = String(
								facetItem.countValue ?? facetItem.value
							)
							const matchedOptions =
								responseFacetItem.options.filter((item) =>
									String(item.value)
										.toLowerCase()
										.split(',')
										.includes(matchValue)
								)

							// if there's any match found, sum the count for every matched facet option
							// following the same example above, the 'nsw' state option count will be updated to 84 in the store
							this.facets[responseFacetKey][
								facetItemIndex
							].count = matchedOptions.length
								? matchedOptions.reduce(
										(currentCount, { count }) =>
											currentCount + count,
										0
									)
								: null
						}
					)

					continue
				}

				// All Models of every vehicle are now consolidated into 1 array in the API.
				// We need to filter through the Models array to only display the relevant Models
				// associated with the selected Makes.
				if (responseFacetKey === 'models') {
					// Use this.filters.makes as this is where the selected Makes are stored.
					const { makes } = this.filters
					// And filter through the Models based on selected Makes.
					const filteredModels = responseFacetItem.options.filter(
						(model) => makes.includes(model.make)
					)
					// And assign the filteredModels to the facets array via the responseFacetKey
					facets[responseFacetKey] = filteredModels
				} else {
					facets[responseFacetKey] = responseFacetItem.options
				}
			}

			await this.updateFacets(facets)
		},
		setProducts(payload) {
			this.products = payload
		},
		updateProductsPagination(payload) {
			// ref - https://v3.vuejs.org/guide/change-detection.html#declaring-reactive-properties
			this.productsPagination = {
				...this.productsPagination,
				...payload,
			}

			const calculatedPage = this.productsPagination.filterNextPage
				? this.productsPagination.filterNextPage
				: this.productsPagination.currentPage

			this.productsPagination.isLastPage =
				calculatedPage === this.productsPagination.lastPage

			if (this.productsPagination.isLastPage) {
				this.productsPagination.nextPage = null
			} else {
				this.productsPagination.nextPage = calculatedPage + 1
			}

			if (calculatedPage === 1) {
				this.productsPagination.prevPage = null
			} else {
				this.productsPagination.prevPage = calculatedPage - 1
			}
		},
		setFilteringState(payload) {
			this.isFiltering = payload
		},
		setIsDirtyState(payload) {
			this.isDirty = payload
		},
		setSilentFilterState(payload) {
			this.isSilentFilter = payload
		},
		async silentFilter(callback) {
			await this.setSilentFilterState(true)

			await callback()

			await this.setSilentFilterState(false)
		},
		getPageMetaFromFilters(titleSlug) {
			const meta = {
				type: '',
				slug: '',
				onPageTitle: '',
				title: '',
				description: '',
			}

			/****
			 * ON PAGE TITLE
			 *
			 * title will be [condition] [fueltype] [bodystyle] [make] [model] in [state]
			 *    new or used Honda Accord
			 *    new or used electric cab chassis nissan or toyota in Victoria
			 ****/

			// "new or used"
			if (this.activeFilters.conditions) {
				meta.onPageTitle = this.getLabelByActiveFilterKey(
					'conditions',
					true
				)
			}

			// "electric or diesel"
			if (this.activeFilters.fuelTypes) {
				meta.onPageTitle = `${
					meta.onPageTitle
				} ${this.getLabelByActiveFilterKey('fuelTypes', true)}`
			}

			// "hatchback or coupe"
			if (this.activeFilters.bodyTypes) {
				meta.onPageTitle = `${
					meta.onPageTitle
				} ${this.getLabelByActiveFilterKey('bodyTypes', true)}`
			}

			// "nissan or toyota"
			if (this.activeFilters.makes) {
				if (this.facets.makes.length > 0) {
					meta.onPageTitle = `${
						meta.onPageTitle
					} ${this.getLabelByActiveFilterKey('makes', true)}`
				} else {
					meta.onPageTitle = `${meta.onPageTitle} ${makeOrList(
						this.filters.makes.map(
							(item) =>
								item.charAt(0).toUpperCase() + item.slice(1)
						)
					)}`
				}
			}

			// "navara or hilux"
			if (this.activeFilters.models) {
				if (this.facets.models.length > 0) {
					meta.onPageTitle = `${
						meta.onPageTitle
					} ${this.getLabelByActiveFilterKey('models', true)}`
				} else {
					meta.onPageTitle = `${meta.onPageTitle} ${makeOrList(
						this.filters.models.map(
							(item) =>
								item.charAt(0).toUpperCase() + item.slice(1)
						)
					)}`
				}
			}

			// "in Victoria (VIC) or New South Wales (NSW)"
			if (this.activeFilters.states) {
				const joiningIn = meta.onPageTitle !== '' ? ' in ' : ' '

				meta.onPageTitle = `${
					meta.onPageTitle
				}${joiningIn}${this.getLabelByActiveFilterKey('states', true)}`
			}

			meta.onPageTitle = `${meta.onPageTitle.trim()} ${titleSlug}`

			/****
			 * HEADER TITLE & DESCRIPTION
			 */

			if (this.activeFilters.bodyTypes && this.activeFilters.makes) {
				meta.type = 'makebodytype'
				meta.slug = `${this.activeFilters.makes.map(_upperFirst).join(', ')} ${this.activeFilters.bodyTypes.map(_upperFirst).join(', ')}`
			} else if (this.activeFilters.makes && this.activeFilters.models) {
				meta.type = 'model'
				meta.slug = `${this.activeFilters.makes.map(_upperFirst).join(', ')}, ${this.activeFilters.models.map(_upperFirst).join(', ')}`
			} else if (this.activeFilters.makes) {
				meta.type = 'make'
				meta.slug = this.activeFilters.makes
					.map((item) => _startCase(_toLower(item)))
					.join(', ')
			} else if (this.activeFilters.bodyTypes) {
				meta.type = 'bodytype'
				meta.slug = _startCase(this.activeFilters.bodyTypes[0])
			} else if (this.activeFilters.fuelTypes) {
				meta.type = 'fueltype'
				meta.slug = _startCase(this.activeFilters.fuelTypes[0])
			} else if (this.activeFilters.states) {
				meta.type = 'state'
				meta.slug = this.activeFilters.states.join(', ').toUpperCase()
			} else {
				meta.type = 'default'
			}

			meta.title = subscriptionPageTitles[meta.type].title
			meta.description = subscriptionPageTitles[meta.type].description

			// replacing the patterns
			meta.title = meta.title.replace('{{ slug }}', meta.slug)
			meta.description = meta.description.replace('{{ slug }}', meta.slug)

			// Add current page number to the title if its set
			if (
				this.productsPagination.currentPage &&
				this.productsPagination.currentPage > 1
			) {
				meta.onPageTitle = `${meta.onPageTitle} Page ${this.productsPagination.currentPage}`
				meta.title = meta.title.replace(
					'{{ page }}',
					`Page ${this.productsPagination.currentPage}` + ' '
				)
			} else {
				meta.title = meta.title.replace('{{ page }}', '')
			}

			return meta
		},
		getLabelByActiveFilterKey(filterKey, orList, getValue) {
			const currentActiveFilters = _cloneDeep(this.activeFilters)
			const currentFacets = _cloneDeep(this.facets)
			const facetItems = currentFacets[filterKey]

			if (!currentActiveFilters[filterKey]) {
				return 'Any'
			}

			const activeFilter = Array.isArray(currentActiveFilters[filterKey])
				? currentActiveFilters[filterKey]
				: [currentActiveFilters[filterKey]]

			if (
				[
					'odometerFrom',
					'odometerTo',
					'priceUsedFrom',
					'priceUsedTo',
					'priceFrom',
					'priceTo',
					'yearFrom',
					'yearTo',
					'sortBy',
				].includes(filterKey)
			) {
				if (filterKey === 'sortBy') {
					const facetItem = _find(
						facetItems,
						(innerFacetItem) =>
							innerFacetItem.slug === activeFilter[0]
					)
					return facetItem.label
				}
				if (orList) {
					return makeOrList(activeFilter)
				}
				return activeFilter.join('')
			}

			const labels = []
			activeFilter.forEach((activeFilterItem) => {
				const facetItem = _find(
					facetItems,
					(innerFacetItem) =>
						`${innerFacetItem.value}`.toLowerCase() ===
						`${activeFilterItem}`.toLowerCase()
				)
				if (getValue) {
					labels.push(facetItem.value.toUpperCase())
				} else if (facetItem && facetItem.label) {
					labels.push(facetItem.label)
				}
			})

			if (orList) {
				return makeOrList(labels)
			}
			return labels.join(', ')
		},
		fetchPage(pageType) {
			if (pageType !== this.pageType) {
				this.$reset()
				this.pageType = pageType
			}

			const { partnerName } = useGetPartnerName()

			if (partnerName.value) {
				this.$reset()
				this.partnerKey = partnerName.value
			}
		},
		resetStore() {
			this.$reset()
		},
	},
})

if (import.meta.hot) {
	import.meta.hot.accept(acceptHMRUpdate(useProductCatalog, import.meta.hot))
}
